import React from 'react';
import buttonStyles from '../../styles/Buttons.module.css';
import styles from './EmptyState.module.css';

// Default empty state image
const DEFAULT_EMPTY_IMAGE = '/images/notasks.png';

interface EmptyStateProps {
  icon?: React.ReactNode;
  image?: string;
  title: string;
  description: string;
  action?: {
    label: string;
    onClick: () => void;
  };
}

const EmptyState: React.FC<EmptyStateProps> = ({ icon, image, title, description, action }) => {
  const displayImage = image || (!icon ? DEFAULT_EMPTY_IMAGE : null);

  return (
    <div className={styles.emptyState}>
      {displayImage ? (
        <div className={styles.emptyImage}>
          <img 
            src={displayImage} 
            alt={title}
            onError={(e) => {
              const target = e.target as HTMLImageElement;
              target.onerror = null;
              target.src = DEFAULT_EMPTY_IMAGE;
            }}
          />
        </div>
      ) : icon ? (
        <div className={styles.emptyIcon}>
          {icon}
        </div>
      ) : null}
      <h3 className={styles.emptyTitle}>{title}</h3>
      <p className={styles.emptyDescription}>{description}</p>
      {action && (
        <div className={styles.emptyAction}>
          <button 
            className={`${buttonStyles.btn} ${buttonStyles.btnPrimary}`}
            onClick={action.onClick}
          >
            {action.label}
          </button>
        </div>
      )}
    </div>
  );
};

export default EmptyState;
